import { apiRequest } from "./client";

export const projectsApi = {
  list() {
    return apiRequest("/projects");
  },

  create(payload) {
    return apiRequest("/projects", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  get(projectId) {
    return apiRequest(`/projects/${projectId}`);
  },

  getDeployment(projectId) {
    return apiRequest(`/projects/${projectId}/deployment`);
  },

  retryDeployment(projectId) {
    return apiRequest(`/projects/${projectId}/deployment/retry`, {
      method: "POST",
    });
  },

  requestDomain(projectId, payload) {
    return apiRequest(`/projects/${projectId}/domain`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  getDomain(projectId, params = {}) {
    return apiRequest(`/projects/${projectId}/domain`, { params });
  },

  verifyDomain(projectId, payload = {}) {
    return apiRequest(`/projects/${projectId}/domain/verify`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  unlinkDomain(projectId, payload = {}) {
    return apiRequest(`/projects/${projectId}/domain`, {
      method: "DELETE",
      body: JSON.stringify(payload),
    });
  },

  update(projectId, payload) {
    return apiRequest(`/projects/${projectId}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },

  listMembers(projectId) {
    return apiRequest(`/projects/${projectId}/members`);
  },

  addMember(projectId, payload) {
    return apiRequest(`/projects/${projectId}/members`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  updateMember(projectId, memberId, payload) {
    return apiRequest(`/projects/${projectId}/members/${memberId}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },

  removeMember(projectId, memberId) {
    return apiRequest(`/projects/${projectId}/members/${memberId}`, {
      method: "DELETE",
    });
  },
};
